import React from "react";
import Managing from "../components/ui/managing";

const ManageUsersPage = () => {
  return <Managing />;
};

export default ManageUsersPage;
